export const mcc = [
    { code: "0742", name: "VETERINARY SERVICE" },
    { code: "0744", name: "CHAMPAGNE PRODUCERS (NO LONGER UTILIZED)" },
    { code: "0763", name: "AGRICULTURAL CO-OP" },
    { code: "0780", name: "LANDSCAPE/HORTICULTUR" },
    { code: "1520", name: "GENERAL CONTRACTOR" },
    { code: "1711", name: "HEATING/PLUMBING/AC" },
    { code: "1731", name: "ELECTRICAL CONTRACTOR" },
    { code: "1740", name: "MASONRY/TILE/INSULATE" },
    { code: "1750", name: "CARPENTRY CONTRACTOR" },
    { code: "1761", name: "ROOFING & SIDING" },
    { code: "1771", name: "CONCRETE WORK" },
    { code: "1799", name: "MISC CONTRACTOR" },
    { code: "2741", name: "PUBLISHING/PRINTING" },
    { code: "2791", name: "TYPESETTING SERVICE" },
    { code: "2842", name: "SANITATION/POLISHING/SPECIALTY CLEANING" },
    { code: "4011", name: "RAILROADS (FREIGHT)" },
    { code: "4111", name: "TRANSPORTATION LOCAL/COMMUTER" },
    { code: "4112", name: "PASSENGER RAILWAYS" },
    { code: "4119", name: "AMBULANCE SERVICE" },
    { code: "4121", name: "TAXICAB & LIMOUSINE" },
    { code: "4131", name: "BUS LINES" },
    { code: "4214", name: "FREIGHT & MOVING" },
    { code: "4215", name: "COURIER SERVICE" },
    { code: "4225", name: "WAREHOUSING & STORAGE" },
    { code: "4411", name: "STEAMSHIP AND CRUISE LINES" },
    { code: "4457", name: "BOAT RENTAL AND LEASING" },
    { code: "4468", name: "MARINAS/SERVICE/SUPPLY" },
    { code: "4511", name: "AIRLINE AND AIR CARRIERS" },
    { code: "4582", name: "AIRPORT & TERMINAL" },
    { code: "4722", name: "TRAVEL AGENCY" },
    { code: "4723", name: "PACKAGE TOUR OPERATORS-GERMANY" },
    { code: "4784", name: "TOLLS AND BRIDGE FEES" },
    { code: "4789", name: "MISC TRANSPORTATION" },
    { code: "4812", name: "TELECOM EQUIPMENT/SALES" },
    { code: "4814", name: "TELECOM SERVICES" },
    { code: "4816", name: "COMPUTER NETWORK/INFO SERVICES" },
    { code: "4821", name: "TELEGRAPH SERVICES" },
    { code: "4829", name: "MONEY TRANSFER" },
    { code: "4899", name: "CABLE/SATELLITE/OTHER STREAMING SVS" },
    { code: "4900", name: "PUBLIC UTILITIES" },
    { code: "5013", name: "AUTO SUPPLIES & PARTS" },
    { code: "5021", name: "OFFICE FURNITURE" },
    { code: "5039", name: "CONSTRUCTION MATERIAL" },
    { code: "5044", name: "COPY SERVICES EQUIPMENT AND SUPPLIES" },
    { code: "5045", name: "COMPUTERS & EQUIPMENT" },
    { code: "5046", name: "COMMERICAL EQUIPMENT" },
    { code: "5047", name: "MEDICAL/DENTAL EQUIPMENT" },
    { code: "5051", name: "METAL SERVICE CENTER" },
    { code: "5065", name: "ELECTRICAL EQUIPMENT" },
    { code: "5072", name: "HARDWARE EQUIPMENT" },
    { code: "5074", name: "PLUMBING/HEATING EQUIPMENT" },
    { code: "5085", name: "INDUSTRIAL SUPPLY" },
    { code: "5094", name: "JEWELRY & WATCHES" },
    { code: "5099", name: "DURABLE GOODS" },
    { code: "5111", name: "STATIONERY/OFFICE SUPPLIES" },
    { code: "5122", name: "DRUGS/SUNDRIES" },
    { code: "5131", name: "FABRICS/DRY GOODS" },
    { code: "5137", name: "COMMERCIAL CLOTHING" },
    { code: "5139", name: "COMMERCIAL FOOTWEAR" },
    { code: "5169", name: "CHEMICALS" },
    { code: "5172", name: "PETROLEUM/PETROLEUM PRODUCTS" },
    { code: "5192", name: "BOOKS & NEWSPAPERS" },
    { code: "5193", name: "FLORISTS' SUPPLIES" },
    { code: "5198", name: "PAINTS & VARNISHES" },
    { code: "5199", name: "NON-DURABLE GOODS" },
    { code: "5200", name: "HOME SUPPLY WAREHOUSE" },
    { code: "5211", name: "LUMBER/BUILDING" },
    { code: "5231", name: "GLASS/PAINT/WALLPAPER" },
    { code: "5251", name: "HARDWARE STORE" },
    { code: "5261", name: "LAWN/GARDEN SUPPLIES" },
    { code: "5262", name: "MARKETPLACES" },
    { code: "5271", name: "MOBILE HOME DEALER" },
    { code: "5300", name: "WHOLESALE CLUB" },
    { code: "5309", name: "DUTY-FREE STORE" },
    { code: "5310", name: "DISCOUNT STORE" },
    { code: "5311", name: "DEPARTMENT STORE" },
    { code: "5331", name: "VARIETY STORE" },
    { code: "5399", name: "GENERAL MERCHANDISE" },
    { code: "5411", name: "GROCERY STORE" },
    { code: "5422", name: "FREEZER & LOCKER MEAT" },
    { code: "5441", name: "CANDY & CONFECTIONERY" },
    { code: "5451", name: "DAIRY PRODUCTS STORE" },
    { code: "5462", name: "BAKERY" },
    { code: "5499", name: "MISC/CONVENIENCE STORE" },
    { code: "5511", name: "AUTO DEALER (NEW/USED)" },
    { code: "5521", name: "AUTO DEALER (USED ONLY)" },
    { code: "5531", name: "AUTO & HOME SUPPLY (MC ONLY)" },
    { code: "5532", name: "AUTOMOTIVE TIRE STORE" },
    { code: "5533", name: "AUTO PARTS/ACCESSORY" },
    { code: "5541", name: "GAS STATION" },
    { code: "5542", name: "AUTOMATED FUEL DISPENSER" },
    { code: "5551", name: "BOAT DEALER" },
    { code: "5552", name: "ELECTRIC VEHICLE CHARGING" },
    { code: "5561", name: "CAMPER/TRAILER DEALR" },
    { code: "5571", name: "MOTORCYCLE DEALER" },
    { code: "5592", name: "MOTOR HOME/RV DEALER" },
    { code: "5598", name: "SNOWMOBILE DEALER" },
    { code: "5599", name: "MISC VEHICLE DEALER" },
    { code: "5611", name: "MEN'S CLOTHING" },
    { code: "5621", name: "WOMEN'S CLOTHING" },
    { code: "5631", name: "WOMEN'S ACCESSORIES" },
    { code: "5641", name: "CHILDREN'S CLOTHING" },
    { code: "5651", name: "FAMILY CLOTHING" },
    { code: "5655", name: "SPORTS CLOTHING" },
    { code: "5661", name: "SHOE STORE" },
    { code: "5681", name: "FUR STORE" },
    { code: "5691", name: "MEN'S/WOMEN'S ACCESSORIES" },
    { code: "5697", name: "TAILORS/ALTERATIONS" },
    { code: "5698", name: "WIG & TOUPEE STORE" },
    { code: "5699", name: "MISC APPAREL STORE" },
    { code: "5712", name: "FURNITURE STORE" },
    { code: "5713", name: "FLOOR COVERING STORE" },
    { code: "5714", name: "DRAPERY & WINDOW COVERING" },
    { code: "5718", name: "FIREPLACE, GLASS" },
    { code: "5719", name: "MISC FURNISHINGS" },
    { code: "5722", name: "HOUSEHOLD APPLIANCE STORE" },
    { code: "5732", name: "ELECTRONICS STORE" },
    { code: "5733", name: "MUSIC STORE" },
    { code: "5734", name: "COMPUTER STORE" },
    { code: "5735", name: "RECORD STORE" },
    { code: "5736", name: "VIDEO STORE" },
    { code: "5739", name: "MISC ELECTRONIC SALES" },
    { code: "5811", name: "CATERING/TRUCK STOP" },
    { code: "5812", name: "EATING PLACES/RESTAURANT" },
    { code: "5813", name: "BAR/TAVERN" },
    { code: "5814", name: "FAST FOOD RESTAURANT" },
    { code: "5912", name: "PHARMACY" },
    { code: "5921", name: "PACKAGE STORES - BEER/WINE" },
    { code: "5931", name: "USED MERCH/SECONDHAND STORE" },
    { code: "5932", name: "ANTIQUES STORE" },
    { code: "5933", name: "PAWN SHOP" },
    { code: "5935", name: "WRECKING & SALVAGE YARD" },
    { code: "5937", name: "ANTIQUE SHOP - REPRODUCTION" },
    { code: "5938", name: "ANTIQUE REPRODUCTION STORE" },
    { code: "5939", name: "ANTIQUE STORE (MC ONLY)" },
    { code: "5940", name: "ANTIQUES - SALES (MC ONLY)" },
    { code: "5941", name: "SPORTING GOODS STORE" },
    { code: "5942", name: "BOOK STORE" },
    { code: "5943", name: "OFFICE AND SCHOOL SUPPLY STORE" },
    { code: "5944", name: "JEWELRY STORE" },
    { code: "5945", name: "HOBBY STORE" },
    { code: "5946", name: "CAMERA & PHOTO STORE" },
    { code: "5947", name: "GIFT AND NOVELTY STORE" },
    { code: "5948", name: "LEATHER GOODS" },
    { code: "5949", name: "SEWING/NEEDLEWORK/FABRICS STORE" },
    { code: "5950", name: "GLASSWARE & CHINA SHOP" },
    { code: "5960", name: "DIRECT MARKETING - INSURANCE" },
    { code: "5961", name: "MAIL ORDER CATALOG" },
    { code: "5962", name: "TELEPHONE DIRECT SALES" },
    { code: "5963", name: "DOOR-TO-DOOR SALES" },
    { code: "5964", name: "INTERNET ORDER" },
    { code: "5965", name: "DIRECT MARKETING - DATING SERVICE" },
    { code: "5966", name: "DIRECT MARKETING - OUTBOUND TELEMARKETING MERCHANDISE" },
    { code: "5967", name: "DIRECT MARKETING - INBOUND TELEMARKETING MERCHANDISE" },
    { code: "5968", name: "DIRECT MARKETING - CONTINUITY/SUBSCRIPTION" },
    { code: "5969", name: "DIRECT MARKETING - OTHER DIRECT MARKETERS" },
    { code: "5970", name: "ART DEALER" },
    { code: "5971", name: "GLASS & POTTERY SHOP" },
    { code: "5972", name: "PHILATELIC & NUMISMATIC SUPPLY" },
    { code: "5973", name: "RELIGIOUS GOODS STORE" },
    { code: "5975", name: "HEARING AIDS" },
    { code: "5976", name: "ORTHOPEDIC GOODS" },
    { code: "5977", name: "COSMETIC STORE" },
    { code: "5978", name: "TYPEWRITER STORE" },
    { code: "5979", name: "MISC GOODS" },
    { code: "5992", name: "FLORIST" },
    { code: "5993", name: "CIGAR STORE" },
    { code: "5994", name: "NEWSPAPER & MAGAZINE STORE" },
    { code: "5995", name: "PET STORE" },
    { code: "5996", name: "SWIMMING POOL SALES" },
    { code: "5997", name: "ELECTRIC RAZOR STORE" },
    { code: "5998", name: "TENT STORE" },
    { code: "5999", name: "MISC GENERAL STORE" },
        { code: "6010", name: "FINANCIAL INSTITUTIONS MANUAL CASH" },
        { code: "6011", name: "FINANCIAL INSTITUTIONS AUTOMATED CASH" },
        { code: "6012", name: "FINANCIAL INSTITUTIONS MERCHANDISE" },
        { code: "6051", name: "NON FINANCIAL INSTIT. ACCT FUNDING" },
        { code: "6211", name: "SECURITY BROKERS/DEALERS" },
        { code: "6300", name: "INSURANCE SALES" },
        { code: "6513", name: "REAL ESTATE AGENTS/MGRS RENTALS" },
        { code: "6532", name: "Payment Transaction customer financial inst. MC" },
        { code: "6540", name: "NON FINANCIAL INSTIT. STORED VALUE" },
        { code: "6533", name: "Payment Transaction customer financial inst. MC" },
        { code: "7011", name: "LODGING" },
        { code: "7012", name: "TIMESHARES" },
        { code: "7032", name: "RECREATION CAMP" },
        { code: "7033", name: "CAMPGROUND" },
        { code: "7210", name: "CLEANING/GARMENT" },
        { code: "7211", name: "LAUNDRY SERVICE" },
        { code: "7216", name: "DRY CLEANER" },
        { code: "7217", name: "CARPET CLEANING" },
        { code: "7221", name: "PHOTOGRAPHIC STUDIO" },
        { code: "7230", name: "BEAUTY/BARBER SHOP" },
        { code: "7251", name: "SHOE REPAIR & SHINE" },
        { code: "7261", name: "FUNERAL SERVICE" },
        { code: "7273", name: "DATING SERVICES" },
        { code: "7276", name: "TAX PREPARATION" },
        { code: "7277", name: "COUNSELING SERVICE" },
        { code: "7278", name: "BUYING/SHOPPING CLUBS" },
        { code: "7296", name: "CLOTHING RENTAL" },
        { code: "7297", name: "MASSAGE PARLORS" },
        { code: "7298", name: "HEALTH & BEAUTY SPA" },
        { code: "7299", name: "MISC PERSONAL SERVICE" },
        { code: "7311", name: "ADVERTISING SERVICE" },
        { code: "7321", name: "CONSUMER CREDIT REPORTING AGENCY" },
        { code: "7333", name: "COMMERCIAL PHOTO/ART" },
        { code: "7338", name: "COPY/REPRODUCTION" },
        { code: "7339", name: "SECRETARIAL SUPPORT" },
        { code: "7342", name: "EXTERMINATE/DISINFECT" },
        { code: "7349", name: "CLEANING/JANITORIAL" },
        { code: "7361", name: "EMPLOYMENT AGENCY" },
        { code: "7372", name: "COMPUTER PROGRAMMING" },
        { code: "7375", name: "INFORMATION RETRIEVAL" },
        { code: "7379", name: "COMPUTER MAINTENANCE" },
        { code: "7392", name: "MGMT/CONSULTING/PR" },
        { code: "7393", name: "SECURITY SERVICE" },
        { code: "7394", name: "EQUIPMENT RENTAL" },
        { code: "7395", name: "PHOTO FINISHING" },
        { code: "7399", name: "BUSINESS SERVICE" },
        { code: "7512", name: "AUTOMOBILE RENTAL" },
        { code: "7513", name: "TRUCK RENTAL" },
        { code: "7519", name: "MOTOR HOME REC VEHICLE RENTAL" },
        { code: "7523", name: "PARKING LOT & GARAGE" },
        { code: "7531", name: "AUTO BODY REPAIR" },
        { code: "7534", name: "TIRE REPAIR" },
        { code: "7535", name: "AUTO PAINT SHOP" },
        { code: "7538", name: "AUTO SERVICE" },
        { code: "7542", name: "CAR WASH" },
        { code: "7549", name: "TOWING SERVICE" },
        { code: "7622", name: "ELECTRONICS REPAIR" },
        { code: "7623", name: "AC/REFRIG REPAIR" },
        { code: "7629", name: "APPLIANCE REPAIR" },
        { code: "7631", name: "WATCH/JEWELRY REPAIR" },
        { code: "7641", name: "FURNITURE REPAIR" },
        { code: "7692", name: "WELDING SERVICE" },
        { code: "7699", name: "MISC REPAIR SHOP" },
        { code: "7800", name: "GOVERNMENT OWNED LOTTERIES" },
        { code: "7801", name: "GOVERNMENT LICENSED ON-LINE CASINO" },
        { code: "7802", name: "GOVERNMENT LICENSED HORSE/DOG RACING" },
        { code: "7829", name: "VIDEO PRODUCTION" },
        { code: "7832", name: "MOVIE THEATER" },
        { code: "7841", name: "VIDEO RENTAL STORE" },
        { code: "7911", name: "DANCE HALL & SCHOOL" },
        { code: "7922", name: "TICKET AGENCY" },
        { code: "7929", name: "MISC ENTERTAINER" },
        { code: "7932", name: "BILLIARD & POOL" },
        { code: "7933", name: "BOWLING ALLEY" },
        { code: "7941", name: "COMMERCIAL SPORTS" },
        { code: "7991", name: "WINERIES" },
        { code: "7992", name: "PUBLIC GOLF COURSE" },
        { code: "7993", name: "VIDEO GAME SUPPLY" },
        { code: "7994", name: "VIDEO GAME ARCADE" },
        { code: "7995", name: "BETTING/LOTTERY TICKETS/GAMING CHIPS" },
        { code: "7996", name: "AMUSEMENT PARK" },
        { code: "7997", name: "MEMBERSHIP CLUB" },
        { code: "7998", name: "AQUARIUM" },
        { code: "7999", name: "RECREATION SERVICE" },
        { code: "8011", name: "DOCTOR & PHYSICIAN" },
        { code: "8021", name: "DENTIST/ORTHODONTIST" },
        { code: "8031", name: "OSTEOPATHS" },
        { code: "8041", name: "CHIROPRACTOR" },
        { code: "8042", name: "OPTOMETRIST/OPHTHALMOLOGIST" },
        { code: "8043", name: "OPTICIAN/EYEGLASSES" },
        { code: "8049", name: "PODIATRIST/CHIROPODIST" },
        { code: "8050", name: "NURSING/PERSONAL CARE" },
        { code: "8062", name: "HOSPITAL" },
        { code: "8071", name: "MEDICAL & DENTAL LAB" },
        { code: "8099", name: "MEDICAL SERVICES" },
        { code: "8111", name: "LEGAL SERVICES" },
        { code: "8211", name: "ELEMENTARY SECONDARY SCHOOL" },
        { code: "8220", name: "COLLEGES/UNIVERSITIES" },
        { code: "8241", name: "CORRESPONDENCE SCHOOLS" },
        { code: "8244", name: "BUSINESS/SECRETARIAL SCHOOL" },
        { code: "8249", name: "TRADE/VOCATION SCHOOL" },
        { code: "8299", name: "EDUCATIONAL SERVICE" },
        { code: "8351", name: "CHILD CARE SERVICE" },
        { code: "8398", name: "CHARITABLE ORGANIZATIONS" },
        { code: "8641", name: "CIVIC & SOCIAL ASSOC" },
        { code: "8651", name: "POLITICAL ORGANIZATIONS" },
        { code: "8661", name: "RELIGIOUS ORGANIZATIONS" },
        { code: "8675", name: "AUTOMOBILE ASSOCIATIONS" },
        { code: "8699", name: "MEMBERSHIP ORGANIZATIONS" },
        { code: "8734", name: "TESTING LABORATORIES" },
        { code: "8931", name: "ACCOUNTING/AUDIT/BOOKKEEPING" },
        { code: "8999", name: "PROFESSIONAL SERVICE" },
        { code: "9211", name: "COURT COSTS" },
        { code: "9222", name: "FINES" },
        { code: "9223", name: "BAIL & BOND PAYMENTS" },
        { code: "9311", name: "TAX PAYMENTS" },
        { code: "9399", name: "GOVERNMENT SERVICES" },
        { code: "9402", name: "POSTAL SERVICE" },
        { code: "9405", name: "INTRA-GOVERNMENT PURCHASES" },
];
